import apiClient from './client';

export interface CalendarEvent {
  id: string;
  title: string;
  type: 'session' | 'competition';
  start: string;
  end: string;
  location?: string;
  description?: string;
  status?: string;
  squad?: {
    id: string;
    name: string;
    color: string;
  };
  backgroundColor?: string;
  borderColor?: string;
}

export interface GetCalendarEventsParams {
  start?: string;
  end?: string;
  squadId?: string;
  type?: 'session' | 'competition' | 'all';
}

export const calendarAPI = {
  getCalendarEvents: async (params?: GetCalendarEventsParams) => {
    const response = await apiClient.get('/calendar', { params });
    return response.data;
  },

  exportCalendar: async (squadId?: string) => {
    const response = await apiClient.get('/calendar/export', {
      params: { squadId },
      responseType: 'blob',
    });
    return response.data;
  },
};
